import SettingNew from './SettingNew';

export default SettingNew;
